// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5803879d","453":"0edc8927","455":"4e5eb976","977":"fe65ab3d"}[chunkId] + ".chunk.js";
};